import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Irigoyen
 * id E1849947-175A-4347-BFC7-D8C7811F0B2B
 * name trademark
 * version: 2.6.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/trademark.svg
 * tags
 */
export const TrademarkIcon = createSvgIcon(<><path d="M9.8,8.44H6.87V16H4.89V8.44H2V7H9.8V8.44M13.5,7L15.96,13.5L18.41,7H21V16H19V13.5L19.22,9.24L16.63,16H15.28L12.7,9.25L12.9,13.5V16H10.93V7H13.5Z" /></>, 'TrademarkIcon');
export default TrademarkIcon